import clsx from 'clsx'
import { PropsWithChildren } from 'react'

export type ContainerProps = PropsWithChildren<{
  className?: string
}>

export default function Container({ className, ...props }: ContainerProps) {
  return <div className={clsx('mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', className)} {...props} />
}
